import { render, staticRenderFns } from "./service_banner.vue?vue&type=template&id=6a081684&scoped=true"
import script from "./service_banner.vue?vue&type=script&lang=js"
export * from "./service_banner.vue?vue&type=script&lang=js"
import style0 from "./service_banner.vue?vue&type=style&index=0&id=6a081684&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a081684",
  null
  
)

export default component.exports